<template>
  <form-field-input
    :label="label"
    v-model="filterValue"
    :help-text="helpText"
    @change="handleInput"
    type="number"
  ></form-field-input>
</template>

<script>
export default {
  name: "FilterBaths",
  props: {
    label: {
      type: String,
      default: "Bathrooms"
    },
    helpText: String,
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].baths;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "baths",
          value
        ]);
      }
    },
    text() {
      return (this.filterValue)
        ? `Baths: ${this.filterValue}`
        : null
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
